import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { OAuthService } from '@shared/service/auth/o-auth.service';
import { map, Observable } from 'rxjs';

export const loginGuard: CanActivateFn = (): Observable<boolean> =>
  // `isAuthenticated$()` waits for MSAL to finish processing a redirect
  // response. Delaying the activation until then is what makes this guard
  // useful: it guarantees that subsequent guards (e.g. AdminGuard) and the
  // activated components can already send requests carrying a bearer token.
  // A missing login is handled by `OAuthService.initializeAuth()`, which
  // triggers the login redirect, so the navigation is never blocked here.
  inject(OAuthService)
    .isAuthenticated$()
    .pipe(map((): boolean => true));
